




import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountService } from '../../shared/account.service';

@Injectable({
  providedIn: 'root'
})
export class CanactivateAgentService implements CanActivate {

  constructor(private router: Router , private accountService : AccountService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.accountService.isAgent().pipe(
      map(isAgent => {
        if (isAgent) {
          if (state.url === '/') {
            return this.router.parseUrl('/agent'); // Redirect to /agent if on root URL
          } else {
            return true; // Allow access to other routes if user is an agent
          }
        } else {
          return this.router.parseUrl('/'); // Redirect to root if user is not an agent
        } 
      })
    );
  }
}
